export const fmtRub = (n: number) => n.toLocaleString("ru-RU")

export const pluralizeRu = (n: number, forms: readonly [string, string, string]) => {
  const abs = Math.abs(n) % 100
  const mod10 = abs % 10
  if (abs > 10 && abs < 20) return forms[2]
  if (mod10 > 1 && mod10 < 5) return forms[1]
  if (mod10 === 1) return forms[0]
  return forms[2]
}
